import { FC } from "react";

import type { StripeOnboarding } from "../helpers/useNavigationAction";
import { NavigationButton } from "../NavigationButton";

import { useCurrentUserContext } from "@/common/contexts/CurrentUserContext";
import { useRedirectToStripeButton } from "@/features/StripeOnboarding/useRedirectToStripeButton";

interface StripeOnboardingButtonProps {
  label: string;
  onOpen: (stripeOnboarding: StripeOnboarding) => Promise<void>;
}

export const StripeOnboardingButton: FC<StripeOnboardingButtonProps> = ({ label, onOpen }) => {
  const { organizationHasFinishZeffyOnboarding } = useCurrentUserContext();
  const { getRedirectionLink, isLoading } = useRedirectToStripeButton();
  return (
    <NavigationButton
      label={label}
      isLoading={isLoading}
      onClick={() => onOpen({ hasFinishedOnboarding: organizationHasFinishZeffyOnboarding, getRedirectionLink })}
    />
  );
};
